<template>
  <div class="home"
       align="center"
  >
    <v-system-bar
      v-if="labels && labels.length > 0"
      height="40"
      window
      fixed
      color="#0073d1"
      class="white--text"
    >
      <v-spacer></v-spacer>
      <span style="font-weight: bold;">Waybill<span v-if="labels.length > 1">s</span>: </span>

      <a
        :href="getPdfLink(labelNumber)"
        v-bind:key="label.trackingNumber"
        v-for="(label, labelNumber) in labels"
        style="padding: 4px; text-decoration: none;"
        target="_blank"
        class="white--text"
      ><v-icon color="white" style="margin-left: 4px;">mdi-barcode-scan</v-icon> <span style="text-decoration: underline;">{{label.trackingNumber}}</span></a>
      <v-spacer></v-spacer>

    </v-system-bar>


    <!-- This card represents the form wrapper.  👇 -->
    <v-card
        max-width="800"
    >
      <v-card-text align="left">

        <v-form
            ref="form"
            v-model="valid"
            :disabled="disabled"
        >
          <v-card
              style="background-color: #5598d5; color: white"
              class="pa-2"
              elevation="4"
          >
            When completing the billing account number field in the web form, please provide the billing
            account number from your Spectrum invoice.<br/>
            Account Number Examples: <b>8260180082801653</b>, <b>926131901</b>, <b>3471515-02</b>
          </v-card>
          <v-text-field
              v-model="billingAccountNumber"
              label="Billing Account Number"
              required
              :rules="bacRules"
              @blur="billingAccountChanged"
          ></v-text-field>
          <v-text-field
              v-model="companyName"
              label="Company Name"
              required
              :rules="companyNameRules"
          ></v-text-field>

          <v-card
              class="mx-auto"
              outlined>
          <v-card-title>Contact Information</v-card-title>
          <v-card-text>
            <v-text-field
                v-model="contactName"
                :rules="nameRules"
                label="Name"
                required
            ></v-text-field>

            <v-card
                style="background-color: #5598d5; color: white"
                class="pa-2"
                elevation="4"
            >
              This web form should be utilized when it is <b>2 weeks minimum past the disconnect date agreed
              with Spectrum and you did not receive an email for truck roll scheduling to pick up equipment
              no longer needed (Fiber or Coax)</b>.<br/><br/>
              Upon submission of this web form, you will automatically receive pre-paid shipping labels that
              you can print and apply to boxes to return ship via FedEx. You can either drop off at a FedEx
              location or contact FedEx to schedule a pickup.
            </v-card>

            <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="customerDueDate"
                    label="Spectrum Disconnect Due Date"
                    prepend-icon="mdi-calendar-range"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    required
                    :rules="existRules"
                ></v-text-field>
              </template>
              <v-date-picker
                  ref="picker"
                  v-model="customerDueDate"
                  min="2019-01-01"
                  @change="savedate"
              ></v-date-picker>
            </v-menu>
            <v-text-field
                v-model="contactEmail"
                :rules="emailRules"
                label="Email"
                required
            ></v-text-field>
            <v-text-field
                v-model="contactPhone"
                :rules="phoneRules"
                label="Phone Number"
                required
            ></v-text-field>
          </v-card-text>
          </v-card>

          <v-card
              class="mx-auto my-2"
              outlined>
            <v-card-title>Return From Address</v-card-title>
            <v-card-text>
              <v-text-field
                  v-model="returningFromStreet"
                  label="Street Address"
                  required
                  :rules="existRules"
              ></v-text-field>
              <v-row>
                <v-col cols="12"
                       xs="12"
                       sm="4"
                       md="4"
                       lg="4">
                  <v-text-field
                      v-model="returningFromZip"
                      label="Zipcode"
                      required
                      :rules="existRules"
                  ></v-text-field>
                </v-col>

                <v-col cols="12"
                       xs="12"
                       sm="4"
                        md="4"
                        lg="4">
                    <v-text-field
                        v-model="returningFromCity"
                        label="City"
                        required
                        :rules="existRules"
                    ></v-text-field>
                </v-col>

                <v-col cols="12"
                       xs="12"
                       sm="4"
                       md="4"
                       lg="4">
                  <v-text-field
                      v-model="returningFromState"
                      label="State"
                      required
                      :rules="existRules"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-container v-if="fedexLocations.length > 0 && doYouHaveRegularFedexPickup === 'no'"
            class="pa-0">
            <v-row no-gutters>
              <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
              >
                <h2>Fedex Drop-off Locations</h2>
              </v-col>
              <v-col
                  cols="auto"
                  md="9"
              >
                <GmapMap
                    :center="mapCenter"
                    :zoom="13"
                    map-type-id="roadmap"
                    :style="{width: mapWidth, height: mapHeight}"
                >
                  <GmapMarker
                      :key="location.id"
                      v-for="(location) in fedexLocations"
                      :position="location.coordinates"
                      :clickable="true"
                      :draggable="true"
                      @click="center=location.coordinates"
                      :icon="location.icon"
                  />
                </GmapMap>
              </v-col>
              <v-col
                  cols="auto"
                  md="3"
              >
                <div id="markers_info" class="ml-1">
                  <div class="marker mb-3"
                       v-bind:key="location.id"
                       v-for="(location, index) in fedexLocations"
                       @mouseover="fedexLocations[index].icon = redIcon"
                       @mouseout="fedexLocations[index].icon = greenIcon"
                  >
                    <v-row no-gutters>
                      <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                      >{{ location.addressLine1 }}</v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                      >{{ `${location.addressCity}, ${location.postalCode}` }}</v-col>
                    </v-row>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>

          <v-card
              style="background-color: #5598d5; color: white"
              class="pa-2"
              elevation="4"
          >
            If you have a large sized piece of Spectrum equipment, greater than what would fit into a
            standard (17x14x9) box, in the number of boxes field, choose 5+. No shipping label will be
            provided and instead we will reach out to you to schedule a special truck roll to pick this up.
            <br/><br/>
            If the quantity of CPE you have is greater than 20 pieces or what would fit into 4 boxes,
            populate QTY with actual number of CPE and choose 5+ for the "Total Number of Boxes" drop down. No shipping label will be provided and
            instead we will reach out to you to schedule a special truck roll to pick this up.
          </v-card>

          <v-text-field
              v-model="numberOfItemsToReturn"
              label="Number of Items"
              required
              :rules="numBoxesRule"
          ></v-text-field>

          <v-select
            :items="numberOfBoxesOptions"
            v-model="numberOfBoxesToReturn"
            label="Total Number of Boxes"
            required
            :rules="numBoxesRule"
            persistent-hint
          ></v-select>

          <div style="margin-bottom: 4px;">Do you have regular Fedex pickup?
            <v-btn-toggle
              v-model="doYouHaveRegularFedexPickup"
              borderless
            >
              <v-btn value="yes">
                <v-icon left>mdi-check</v-icon>
                <span class="hidden-sm-and-down">Yes</span>
              </v-btn>
              <v-btn value="no">
                <v-icon left>mdi-close</v-icon>
                <span class="hidden-sm-and-down">No</span>
              </v-btn>
            </v-btn-toggle>
          </div>

          <!--<v-checkbox
              v-model="doYouHaveRegularFedexPickup"
              label="Do you have regular Fedex pickup?"
              required
          ></v-checkbox>
          <v-switch
            v-model="doYouHaveRegularFedexPickup"
            :label="`Do you have regular Fedex pickup? - ${doYouHaveRegularFedexPickup ? 'Yes' : 'No'}`"
          ></v-switch>
          -->
          <v-card
              style="background-color: #5598d5; color: white"
              class="pa-2 my-3"
              elevation="4"
          >
            Any additional questions related to billing, or issues related to customer’s inability to ship
            equipment (such as equipment needed to be physically uninstalled), can be directed to:
            Spectrum Enterprise Client Services at <b>888-812-2591</b>, then select <b>option 2</b>. This team is
            available Monday-Friday from <b>8a-9p ET</b>.
          </v-card>
          <v-textarea
              filled
              v-model="notes"
              label="Notes"
              hint="Enter any additional notes here."
          ></v-textarea>

          <v-list v-if="validationErrors && validationErrors.length > 0 && hasFormBeenEdited">
            <v-list-item><h3>The following fields need to be entered before submitting:</h3></v-list-item>
            <v-list-item
                dense
                v-for="(item, i) in validationErrors"
                :key="i">
              <v-list-item-icon>
                <v-icon>mdi-alert</v-icon>
              </v-list-item-icon>
              {{ item }}
            </v-list-item>
          </v-list>

          <v-btn
              color="#0073d1"
              class="white--text"
              @click="save"
              :disabled="disabled || !valid"
          >
            Submit
          </v-btn>

          <a
              :href="getPdfLink(labelNumber)"
              v-bind:key="label.trackingNumber"
              v-for="(label, labelNumber) in labels"
              style="padding: 4px; text-decoration: none;"
              target="_blank"
          ><v-icon style="margin-left: 4px;">mdi-barcode-scan</v-icon> {{label.trackingNumber}}</a>
          <v-container v-if="showSavingPanel">
            <v-row>
              <v-col cols="12">
                Saving...
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-progress-linear height="10" indeterminate striped />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
    <!-- This card represents the form wrapper.  👆 -->

    <v-dialog
        v-model="returningUserDialog"
        max-width="290"
    >
      <v-card>
        <v-card-title class="headline">We Found You</v-card-title>
        <v-card-text>
          It looks like you filled out this form once before. Would you like to
          retrieve your previously entered information or start over?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="green darken-1"
              text
              @click="newReturn"
          >
            New Return
          </v-btn>

          <v-btn
              color="green darken-1"
              text
              @click="returningUserDialog = false"
          >
            Load Existing
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="pickupRequestedDialog"
        max-width="320"
    >
      <v-card>
        <v-card-title class="headline">Pickup to be arranged.</v-card-title>
        <v-card-text>
          Your return notice has been saved. However,
          due to the volume of equipment on this return,
          someone will be in contact with you to schedule a pickup.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="green darken-1"
              text
              @click="pickupRequestedDialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
        v-model="tooEarlySnackbar"
        timeout="-1"
    >
      Per the Disconnect Agreement, please wait 2 weeks before submitting equipment return request to ensure Spectrum will not be performing a site visit to collect equipment directly.

      <template v-slot:action="{ attrs }">
        <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="tooEarlySnackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<style>
#markers_info .marker {
  height: 40px;
  cursor: pointer;
}

.logoBumpout {
  margin-top: 30px;
}
</style>
<script>
// @ is an alias to /src
import { baseApiUrl } from '@/config';
import debounce from 'lodash.debounce';

export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
      canSubmitDate: true,
      hasPromptedForExistingAccountNumber: false,
      submittedAlready: false,
      valid: false,
      disabled: false,
      showSavingPanel: false,
      firstname: '',
      lastname: '',
      email: '',
      existRules: [
        v => (v && v.length > 1) || 'Required',
      ],
      nameRules: [
        v => !!v || 'Name is required',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      numBoxesRule: [
        v => (v && !Number.isNaN(Number(v)) && Number(v) > 0) || 'Number of boxes is required.',
      ],
      doYouHaveRegularFedexPickup: undefined,
      numberOfBoxesToReturn: undefined,
      numberOfItemsToReturn: undefined,
      phoneRules: [
        v => (v && v.length >= 7) || 'Phone number is required.',
        v => /^[2-9]\d{2}-\d{3}-\d{4}$/.test(v) || 'Phone number should be in ###-###-#### format.',
      ],
      bacRules: [
        v => (v && v.length >= 5) || 'Billing account number is required.',
      ],
      companyNameRules: [
        v => (v && v.length >= 5) || 'Company name is required and must be at least 5 characters.'
      ],
      returningFromState: undefined,
      returningFromCity: undefined,
      returningFromZip: undefined,
      returningFromStreet: undefined,

      contactName: '',
      contactEmail: '',
      contactPhone: '',

      companyName: '',
      billingAccountNumber: '',

      notes: undefined,

      labels: [],

      updatedReturnNotice: undefined,
      customerDueDate: null,
      menu: false,

      tooEarlySnackbar: false,
      returningUserDialog: false,
      pickupRequestedDialog: false,

      validationErrors: [],

      // map
      markers: [],
      fedexLocations: [],
      greenIcon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAABHNCSVQICAgIfAhkiAAAAAZiS0dEAP8A/wD/oL2nkwAAAF96VFh0UmF3IHByb2ZpbGUgdHlwZSBBUFAxAAAImeNKT81LLcpMVigoyk/LzEnlUgADYxMuE0sTS6NEAwMDCwMIMDQwMDYEkkZAtjlUKNEABZiYm6UBoblZspkpiM8FAE+6FWgbLdiMAAADyElEQVRIia2WS2xUVRiAv3Pndl4FTFumtLVUZoIJMYRG0NBEamgwxogLoy7oQliYmLhx48IFuCVE40YSY8rGKCxIakwacQFpKDYUbSnWaRtHGDrD1NLHPNreO487d+bOcdFp6WOm0yL/6t7/8Z3/P/9/7j2C8vIC8AbQCuwq6pKAH+gFHpYKEiV0buBz4JMqp+qp2beDao8LAaRiBolHOrl0PgF0AecBfTOgF+h21zkPH3rfi+94g3TvcSHsNgEgTUtmogahW7PC3z1BMpoZBz4AAqWA+4GbzUc8zR1nW6WzwS0wCpAvrF1SFeC0kYtm6bswQvjO7BxwAhhbDXQBt/e+4nn5zfOvotgVMNeB1otdQRYkveeGCQ3MBICjgGYrms9W1zk73/r6qLRXV4mKMABLIhSF5jaPDPVNe7J6rgq4oQCNwEeHTvlw1bu2BluWfAF7rUO0du4HOAN4VeC46rTt9b3eBBlrjX86kSVwLcJE/wwAvvYGDpxswV3reOKUsdjXvkcOdlV5snruhAocqWnZidvj3NCAwLUIwz8+WHkfDi9NyOEPX1xTurPGIWq9O5n2Jw4qQJ17twOqlA0VLWdWSYdNoXq3C+A5BUAgSo/4NkQU81GA+VTCKDkmvvaGLemwJMmoAaCpwN2FcJJ03FjabEuu+B042QKwoSlrxAbGgiETE5oAxgTwPDD42qcHm1465YNkfnu1ulXu90S49eVIHGhTgCng0l9XghhRQ6JubE5ZUQWmZsqRyw8AvgeCyyflrpnJv6tFkvXejkYpFCGQZTErpUohZP8Fv5j2xyeA00BmGWgCvQuTqff0ydQub0cTFCoQ7TZuf+UX96//GwPeBsLFdVYkDvQlwnqnUhCOxrZ6yJU5hjtUxq9O8OeVoAG8Awwtm9Zv2D3g4+Ef/mF6KAouGxvErpAILMjBSwGAz4D+1eZSHbgq4fLAN+Pk03lZauCHvguIfNa6CXy73laupV8kQtpioCcicKlPtA4bk3fmiAzOAZwrFVgOGAa6xn8OkdfNVVlKxn4KAfwCDGwHCHBRe5xOTv4eFThtoCosPNSZuhcDuFguaDPgJNATvDG19GZXCP02gyxIP3D9aYAA3TOjCcx4FqwCkT9mAXo2C6gE7Dd0czEe1MjGTeJBHeDXzQLUzYxADBiNBbVjILBy1gxLN4enBgIMz4f0YwWrADAKpP4vcFybTmGm81TKbqvAR8m5DJl5E+DvZwGMpeNZij+dyLMA6lauIItErZLzVj7Pi0C6+Byv5LyVDBeBxyxdqKKVnP8DAY+GnvUBGSAAAAAASUVORK5CYII=',
      redIcon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAADo0lEQVRIia2WbWxTVRjH/93WtOvY3JubMFYZSJCXjRBeDCZu8yUaNIrJ+cIXSRYCkegnAmoMSzRRwgc+mCzRoIkE5QMEGnABzJbAlMrm4kQs7JVtdsVu623Xrrdv9+xs1DzNbbNxb9cO90+ae85znufX8zzn5V4D0utZAK8B2AqgSPUKA3AAuAFgRC8yARSMpQxGm80C4GMAh63FK57evLYM1tLChKPLH0afcwpOf8gP4FsAJwRjoXmxC4FGm61mldl8paTcUtfcsBV7Z0qR92jhDOYMwHXzND6/9TckKTw4oSjvCsYGksCcefTnKk2m3+p3WOvuvvAymKKFkXLjwNuxYvTsbMCe3TUbKk0mu9Fm27IgZQD5q8zm7sad1tqzFbWLlFWrw4F+XOscfTChKDsAyMkZflRablkyjPRNyUasripaD6CZ+gRcCeDAF43blgxL6uSL21BpMjUBqCFgY3VxQfWbSrHGkRbgjFHCK/1diR+153Q2Wn10BQqLTGUAXs0DsH3TmjIY4lrHH/IkHDpvT/XtfePAvpfQJCo0vrVryzHslbfQDMuqSgt0U/nRod27ejaStaSQHk8lFsWAxQ5MdspVEQQMuKcjukHv1a3LykZyBuhUQqYa9vSNTgE1Wqf9sxWJmiXTJFjCpiPHiJeM9wn4K4+JyXaL/Mzr0aIFnnQqaAGaNqoQoZ99Z0EEIZkHAHRQym4P56c/6fjziet37PZf8HD+PYDh5Ek55fNFB98P9C0ZdjQyDJc7OEY3D9RFodsmPKEoe6/eHp08Eh7KGvaZcOJ8x4B/UlHeEYz5U0AVOujh/K0LvwyFzhq9GWE/W4L4ru0+93BO15cjac+Z7yQYuyNxfvDTy93wmubSwiLGOD5o7YLE+RHBmH3+WM7jzoKxCxLn5/bd/SMt8MPxXjwMRjoEY18/PqYBqmoeGPHJ1/KnNQOufIG2bic1j+sF6gIFY06J89Nfdt3TjB0fG4CX86uCsc6sgapaxv4NRnotSsoQNcZxs8dFzZZ0QWmBgrGHEuc/tbj/SdlsBh88McUhGGtfMlDVpVv33KnOxUHav2hdLCAT0B6UFXnSPJvoOB746HH9iYGCMZ/EueN3QwgEnZ2ZldQvh/+lrza8UR3fdfB5ekmkrV1SeVn8U688EcFMNJF2xtllAxwLSzHEAjPU7l8OoC86xZMfGa7lAIbmxCOqHxHlTM6Ztg0pSIdEbU8txwwJOE4fVAAWvygB/AcBSXTGrVAQxQAAAABJRU5ErkJggg==',
      mapCenter: undefined,

      numberOfBoxesOptions: [
        { text: '1', value: 1 },
        { text: '2', value: 2 },
        { text: '3', value: 3 },
        { text: '4', value: 4 },
        { text: '5+', value: 5 },
      ],
    }
  },
  computed: {
    hasFormBeenEdited() {
      return (this.billingAccountNumber && this.billingAccountNumber.length > 5) ||
          (this.companyName && this.companyName.length > 0) ||
          (this.contactName && this.contactName.length > 0) ||
          (this.contactPhone && this.contactPhone.length > 0) ||
          (this.contactEmail && this.contactEmail.length > 0) ||
          (this.returningFromZip && this.returningFromZip.length > 0) ||
          (this.returningFromCity && this.returningFromCity.length > 0) ||
          (this.returningFromState && this.returningFromState.length > 0) ||
          (this.returningFromStreet && this.returningFromStreet.length > 0) ||
          (this.numberOfBoxesToReturn && this.numberOfBoxesToReturn.length > 0) ||
          (this.customerDueDate && this.customerDueDate.length > 0) ||
          (this.numberOfItemsToReturn && this.numberOfItemsToReturn.length > 0);
    },
    /*canSubmit() {

      debugger; // eslint-disable-line no-debugger

      return (this.billingAccountNumber && this.billingAccountNumber.length > 5) &&
        (this.companyName && this.companyName.length > 0) &&
        (this.contactName && this.contactName.length > 0) &&
        (this.contactPhone && this.contactPhone.length > 0) &&
        (this.contactEmail && this.contactEmail.length > 0) &&
        (this.returningFromZip && this.returningFromZip.length > 0) &&
        (this.returningFromCity && this.returningFromCity.length > 0) &&
        (this.returningFromState && this.returningFromState.length > 0) &&
        (this.returningFromStreet && this.returningFromStreet.length > 0) &&
        (!Number.isNaN(Number(this.numberOfBoxesToReturn)) && Number(this.numberOfBoxesToReturn) > 0) &&
        (this.numberOfItemsToReturn && this.numberOfItemsToReturn.length > 0) &&
        (this.customerDueDate && this.customerDueDate.length > 0) &&
        !this.submittedAlready
    },*/
      mapHeight () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '400px';
          default: return '500px';
        }
      },
      mapWidth () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '260px';
          case 'sm': return '500px';
          default: return '550px';
        }
      },
  },
  async mounted() {
    console.log('on mounted. id:', this.$route.query.id);

    if (!this.$route.query.id) return;

    const resp = await fetch(`${baseApiUrl}/return-notice/${this.$route.query.id}`);
    console.log('resp:\n', resp);
    if (resp.status === 200) {
      const returnNotice = await resp.json();
      console.log(returnNotice);
      Object.assign(this, {...returnNotice});
      this.updatedReturnNotice = returnNotice;
    }
  },
  beforeUpdate() {
    if (this.hasFormBeenEdited) {
      this.validationErrors = [];

      /*
      this.companyName &&
      this.contactName &&
      this.contactPhone &&
      this.contactEmail &&
      this.returningFromZip &&
      this.returningFromCity &&
      this.returningFromState &&
      this.returningFromStreet &&
      this.numberOfBoxesToReturn &&
      this.numberOfItemsToReturn &&
      !this.submittedAlready */

      if (!this.billingAccountNumber) {
        this.validationErrors.push('Billing Account Number');
      }

      if (!this.companyName) {
        this.validationErrors.push('Company Name');
      }

      if (!this.contactName) {
        this.validationErrors.push('Contact Name');
      }

      if (!this.contactPhone) {
        this.validationErrors.push('Contact Phone');
      }

      if (!this.contactEmail) {
        this.validationErrors.push('Contact Email');
      }

      if (!this.returningFromStreet) {
        this.validationErrors.push('Street Address');
      }

      if (!this.returningFromCity) {
        this.validationErrors.push('City');
      }

      if (!this.returningFromZip) {
        this.validationErrors.push('Zipcode');
      }

      if (!this.returningFromState) {
        this.validationErrors.push('State');
      }

      if (Number.isNaN(Number(this.numberOfBoxesToReturn)) || Number(this.numberOfBoxesToReturn) < 1) {
        this.validationErrors.push('Number of Boxes');
      }

      if (!this.numberOfItemsToReturn) {
        this.validationErrors.push('Number of Items');
      }

      if (!this.customerDueDate) {
        this.validationErrors.push('Spectrum Disconnect Due Date');
      }
    }
  },
  methods: {
    savedate: function (date) {
      // this.$refs.menu.save(date)
      console.log('save date:', date);
      const daysSinceDue = Math.ceil((new Date() - new Date(date)) / (1000 * 3600 * 24));

      this.tooEarlySnackbar = (daysSinceDue < 10);
      this.canSubmitDate = !(daysSinceDue < 10);
    },
    save: async function () {
      const returnNotice = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        doYouHaveRegularFedexPickup: this.doYouHaveRegularFedexPickup,
        numberOfBoxesToReturn: this.numberOfBoxesToReturn,
        numberOfItemsToReturn: this.numberOfItemsToReturn,
        returningFromState: this.returningFromState,
        returningFromCity: this.returningFromCity,
        returningFromZip: this.returningFromZip,
        returningFromStreet: this.returningFromStreet,
        contactName: this.contactName,
        contactEmail: this.contactEmail,
        contactPhone: this.contactPhone,
        companyName: this.companyName,
        billingAccountNumber: this.billingAccountNumber,
        notes: this.notes,
        customerDueDate: this.customerDueDate,
      };

      if (this.$route.query.id) {
        returnNotice._id = this.$route.query.id;
      }

      this.showSavingPanel = true;
      this.submittedAlready = true;
      const resp = await fetch(`${baseApiUrl}/return-notice`, { method: 'POST', body: JSON.stringify(returnNotice, null, 0)});

      // wrote return notice.. now get labels.
      if (resp.status !== 200) {
        // TODO: display error.
        return;
      }

      const updatedRN = await resp.json();

      console.log(updatedRN);

      if (!updatedRN.shouldRequestLabels) {
        this.updatedReturnNotice = updatedRN;
        this.pickupRequestedDialog = true;
        this.showSavingPanel = false;
        this.disabled = true;
        return;
      }

      const labelWindow = window.open("/waybills", "_blank");

      // get labels from api
      const labelResp = await fetch(`${baseApiUrl}/ship-label/${updatedRN._id}`, { method: 'POST', body: JSON.stringify(updatedRN, null, 0)});
      const labelResult = await labelResp.json();

      console.log('labelResp:', labelResp);
      console.log('labelResult:', labelResult);

      // update the RN
      updatedRN.labels = labelResult.labels;
      await fetch(`${baseApiUrl}/return-notice`, { method: 'POST', body: JSON.stringify(updatedRN, null, 0)});

      this.updatedReturnNotice = updatedRN;
      this.labels = labelResult.labels;
      this.showSavingPanel = false;

      labelWindow.location.href = this.getPdfLink('all');
    },
    getPdfLink: function (labelNumber) {
      return `${baseApiUrl}/ship-label/${this.updatedReturnNotice._id}/${labelNumber}`;
    },
    billingAccountChanged: async function() {
      console.log('billing account changed to:', this.billingAccountNumber);
      if (this.hasPromptedForExistingAccountNumber) return;

      const resp = await fetch(`${baseApiUrl}/return-notice/lookup/${this.billingAccountNumber}`);

      if (resp && resp.status === 200) {
        const rn = await resp.json();
        console.log('found rn:', rn);
        this.firstName = rn.firstName;
        this.lastName = rn.lastName;
        this.email = rn.email;
        this.doYouHaveRegularFedexPickup = rn.doYouHaveRegularFedexPickup;
        this.numberOfBoxesToReturn = rn.numberOfBoxesToReturn;
        this.numberOfItemsToReturn = rn.numberOfItemsToReturn;
        this.returningFromState = rn.returningFromState;
        this.returningFromCity = rn.returningFromCity;
        this.returningFromZip = rn.returningFromZip;
        this.returningFromStreet = rn.returningFromStreet;
        this.contactName = rn.contactName;
        this.contactEmail = rn.contactEmail;
        this.contactPhone = rn.contactPhone;
        this.companyName = rn.companyName;
        this.billingAccountNumber = rn.billingAccountNumber;
        this.notes = rn.notes;
        this.labels = rn.labels;
        this.customerDueDate = rn.customerDueDate;
        this.updatedReturnNotice = rn;
        this.returningUserDialog = true;
        this.disabled = true;
      } else {
        console.log('could not find rn with ban.', resp);
      }
    },
    newReturn: function() {
      this.hasPromptedForExistingAccountNumber = true;
      this.firstName = undefined;
      this.lastName = undefined;
      this.email = undefined;
      this.doYouHaveRegularFedexPickup = undefined;
      this.numberOfBoxesToReturn = undefined;
      this.numberOfItemsToReturn = undefined;
      this.returningFromState = undefined;
      this.returningFromCity = undefined;
      this.returningFromZip = undefined;
      this.returningFromStreet = undefined;
      this.contactName = undefined;
      this.contactEmail = undefined;
      this.contactPhone = undefined;
      this.companyName = undefined;
      // this.billingAccountNumber = undefined;
      this.notes = undefined;
      this.labels = undefined;
      this.customerDueDate = undefined;
      this.updatedReturnNotice = undefined;
      this.returningUserDialog = false;
      this.disabled = false;
      this.canSubmitDate = true;
      this.$refs.form.resetValidation();
    },
    fetchZipcodeData: debounce(async function () {
      const newZip = this.returningFromZip;
      if (!newZip) return;

      const resp = await fetch(`${baseApiUrl}/zipcode/${newZip}`);
      const json = await resp.json();
      console.log('returningFromZip changed.. zipcode call result json:\n', json);

      if (Array.isArray(json) && json.length >= 1) {
        this.returningFromState = json[0].State;
        this.returningFromCity = json[0].City;
        this.mapCenter = { lat: json[0].Lat, lng: json[0].Long }

        console.log('requesting fedex locations...');
        const resp = await fetch(`${baseApiUrl}/fedex-locations/${json[0].Long}/${json[0].Lat}`);
        const locations = await resp.json();
        console.log('locations:', locations);

        this.markers = locations.map(location => {
          return {
            position: { lat: location.coordinates[1], lng: location.coordinates[0] },
            title: `${location.displayName} - ${location.addressLine1}`,
          };
        });
        let id = 0;
        this.fedexLocations = locations.map(l => {
          id ++;
          return {...l, ...{ id, icon: this.greenIcon, coordinates: { lat: l.coordinates[1], lng: l.coordinates[0] }}};
        });
      }
    }, 600),
  },
  watch: {
    returningFromZip: async function(zip) {
      console.log('returning from zip called:', zip);
      await this.fetchZipcodeData();
    },

  },
}
</script>
